import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d76693a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-img" }
const _hoisted_2 = { class: "text-overflow-2 card-title" }
const _hoisted_3 = { class: "text-overflow-2 card-desc" }
const _hoisted_4 = { class: "card-time" }

import { IProgram } from '@/types/program';
  import dayjs from 'dayjs';
  import { computed } from 'vue';

  export interface IProps {
    program: IProgram,
    sm?: boolean;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null,
    sm: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    program: IProgram,
    sm?: boolean;
  }

  
  const time = computed(() => {
    return [props.program.started_at, props.program.ended_at]
      .filter(Boolean)
      .map(item => dayjs(item).format('YYYY.M.DD'))
      .join('-');
  });

return (_ctx: any,_cache: any) => {
  const _component_AppAutoHeight = _resolveComponent("AppAutoHeight")!
  const _component_AppCustomLink = _resolveComponent("AppCustomLink")!

  return (_openBlock(), _createBlock(_component_AppCustomLink, {
    to: { name: 'programs.show', params: { slug: __props.program.slug } },
    "custom-domain": __props.program.custom_campaign_domain,
    class: _normalizeClass([{ sm: __props.sm }, "card-program"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_AppAutoHeight, {
          height: "71%",
          "image-url": __props.program.image?.url
        }, null, 8, ["image-url"])
      ]),
      _createElementVNode("h6", _hoisted_2, _toDisplayString(__props.program.name), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.program.description), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(time)), 1)
    ]),
    _: 1
  }, 8, ["to", "custom-domain", "class"]))
}
}

})